import { useCallback, useEffect, useState } from 'react';
import { useGetStreamingOverviewQuery } from '../../../../redux/api/fymAPI';
import { useRealtimePollInterval } from '../../../realtime/useRealtimePollInterval';

/** How often the screen reads again while a first read runs and the socket is down (design f5). */
const FIRST_READ_POLL_MS = 5000;

/**
 * The overview of the Streaming screen. While a first read runs, the screen waits for the
 * `artistPortal.synced` event; it polls only while the socket is down.
 */
export function useStreamingOverview(accountId: number, days: number) {
  const [isReading, setReading] = useState(false);
  const pollingInterval = useRealtimePollInterval(isReading ? FIRST_READ_POLL_MS : 0);
  const { data, isLoading, error, refetch } = useGetStreamingOverviewQuery({ accountId, days }, { pollingInterval });

  useEffect(() => {
    setReading((data?.sources ?? []).some((source) => source.state === 'firstRead'));
  }, [data]);

  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);

  return { overview: data, isLoading, error, retry, isReading };
}
